import React, { useState, useEffect } from 'react';
import Typography from 'bharat-ui/web/Typography';
import { makeStyles } from 'bharat-ui/web/Styles';

/*
	CSS Styling
*/
const useStyle = makeStyles(() => ({
	Rectangle4: {
		padding: '0.625rem',
		borderRadius: '0.25rem',
		backgroundColor: '#f4f9ff',
		fontSize: '0.8rem',
	},
	UnityTimerCard: {
		backgroundColor: '#FFFAE8 !important',
		color: '#FFCD1E',
	},
}));

interface Iprops {
	timeLeft: number;
	onTimerUp: boolean;
	children?: any;
	className?: string;
	timerUpAction: () => void;
	isShowUnity?: boolean;
}

/**
 *	@name Timer
 *	@param props
 *	@description Handling Timer Component
 */
const Timer: React.FC<Iprops> = (props) => {
	const [counter, setCounter] = useState(props.timeLeft / 1000);
	const [parsedTime, setParsedTime] = useState('');

	// Using scss
	const classes = useStyle();

	const calTime = () => {
		const newTime = counter - 1;
		setCounter(newTime);
		let min: number | string = calMin(newTime);
		let sec: number | string = calSec(newTime, min);
		min = min.toString();
		sec = sec.toString();
		setParsedTime(`${min.length === 1 ? `0${min}` : min} MIN : ${sec.length === 1 ? `0${sec}` : sec} SEC`);
	};

	const calMin = (time: number) => {
		return parseInt((time / 60).toFixed(2));
	};

	const calSec = (time: number, min: number) => {
		const sec = time - min * 60;
		return sec > 0 ? sec : 0;
	};

	useEffect(() => {
		calTime();
	}, []);

	useEffect(() => {
		if (counter === 0) {
			props.timerUpAction();
		}
		if (counter > 0 && !props.onTimerUp) {
			const time = setTimeout(() => calTime(), 1000);

			return () => clearTimeout(time);
		} else if (props.onTimerUp) {
			setCounter(0);
		}
	}, [counter]);

	if (counter <= 0 && props.children) return props.children;
	return (
		<Typography className={`${props.isShowUnity ? classes.UnityTimerCard : ''} ${classes.Rectangle4}`}>
			{parsedTime}
		</Typography>
	);
};

// Timer.defaultProps = {
//   props.timeLeft: { min: 0, sec: 0 },
//   onTimerUp: () => { },
// };

export default Timer;
